import React from 'react';
import { LogIn, Key, ArrowRight } from 'lucide-react';

// ── Login Gate ────────────────────────────────────────────────────────────────
interface LoginGateProps {
  viewName: string;
  onLogin: () => void;
}

export const LoginGate: React.FC<LoginGateProps> = ({ viewName, onLogin }) => (
  <div className="flex-1 flex flex-col items-center justify-center h-full bg-[#F0F2F5]">
    <div className="bg-white rounded-2xl border border-slate-200 shadow-lg p-10 max-w-sm w-full text-center">
      <div className="w-14 h-14 rounded-full bg-blue-50 flex items-center justify-center mx-auto mb-5">
        <LogIn size={26} className="text-blue-600" />
      </div>
      <h2 className="text-xl font-bold text-slate-800 mb-2">Sign In Required</h2>
      <p className="text-sm text-slate-500 mb-6 leading-relaxed">
        <span className="font-semibold text-slate-700">{viewName}</span> stores personal
        data and requires a free account.
      </p>
      <button
        onClick={onLogin}
        className="w-full flex items-center justify-center gap-2 py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-xl transition-colors"
      >
        Sign In / Create Account
        <ArrowRight size={16} />
      </button>
      <p className="text-xs text-slate-400 mt-4">Free · No credit card required</p>
    </div>
  </div>
);

// ── BYOK Gate ─────────────────────────────────────────────────────────────────
interface BYOKGateProps {
  viewName: string;
  onLogin: () => void;
}

export const BYOKGate: React.FC<BYOKGateProps> = ({ viewName, onLogin }) => (
  <div className="flex-1 flex flex-col items-center justify-center h-full bg-[#F0F2F5]">
    <div className="bg-white rounded-2xl border border-slate-200 shadow-lg p-10 max-w-sm w-full text-center">
      <div className="w-14 h-14 rounded-full bg-violet-50 flex items-center justify-center mx-auto mb-5">
        <Key size={26} className="text-violet-600" />
      </div>
      <h2 className="text-xl font-bold text-slate-800 mb-2">AI Key Required</h2>
      <p className="text-sm text-slate-500 mb-6 leading-relaxed">
        <span className="font-semibold text-slate-700">{viewName}</span> uses AI and
        requires your own Gemini API key. Your key is stored locally and never shared.
      </p>
      <button
        onClick={onLogin}
        className="w-full flex items-center justify-center gap-2 py-3 bg-violet-600 hover:bg-violet-700 text-white font-semibold rounded-xl transition-colors"
      >
        Sign In to Set Up API Key
        <ArrowRight size={16} />
      </button>
      <p className="text-xs text-slate-400 mt-4">
        Sign in first, then add your Gemini key in Profile settings
      </p>
    </div>
  </div>
);
